import { render, staticRenderFns } from "./PublicAgenciesDetailsGeneralData.vue?vue&type=template&id=8b86e760&"
import script from "./PublicAgenciesDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./PublicAgenciesDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports